import { render } from "./SaleDetailsPage.vue?vue&type=template&id=bf5d7a7a&ts=true"
import script from "./SaleDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SaleDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__